import { makeEnum } from '../util/mappingLib.js';

const ErrorCode = makeEnum({
  DUPLICATE_KEY: 'duplicateKey',
  USER_ALREADY_HAS_IRA_ACCOUNT: 'userAlreadyHasIraAccount',
  ACCOUNT_ALREADY_HAS_RECURRING_DEPOSIT: 'accountAlreadyHasRecurringDeposit',
  UPDATE_FAILED: 'updateFailed',
  INVALID_DATA: 'invalidData',
  EXPIRED_DATA: 'expiredData',
  INVALID_REQUEST: 'invalidRequest',
});

const SystemValidationError = makeEnum({
  REQUIRED_SYSTEM_HANDLED: 'requiredSystemProvided', //the UI will provide these values, user should never see this error
  UNEXPECTED_SYSTEM_HANDLED: 'unexpectedSystemHandled', //the UI is designed so the user never sees these errors
  INVALID_ADDITIONAL_FIELDS: 'additionalFieldsNotAllowed', //additional fields not expected
  INVALID_ACCOUNT_STATE_FOR_REQUEST: 'accountInvalidStateForRequest', //account is not in the right part of lifecycle
  INVALID_ACCOUNT_OPERATION: 'invalidAccountOperation', //the operation is not valid for the account (e.g. user trying to hit admin endpoint while not an admin)
});

const AuthorizationError = makeEnum({
  NOT_AUTHENTICATED: 'notAuthenticated',
  INVALID_TOKEN: 'invalidToken',
  EMAIL_NOT_VERIFIED: 'emailNotVerified',
});

export { ErrorCode, SystemValidationError, AuthorizationError };
